import { ReactElement, memo } from "react";
import { theme } from "../../theme";
import { h } from "../../h";

export const RemoveIcon = memo(
    (): ReactElement => {
        return h(
            `svg`,
            {
                width: 27,
                height: 30,
                viewBox: `0 0 27 30`,
            },
            h(`path`, {
                d: `M24 3H22.5V0H19.5V3H7.5V0H4.5V3H3C2.20435 3 1.44129 3.31607 0.87868 3.87868C0.31607 4.44129 0 5.20435 0 6V27C0 27.7956 0.31607 28.5587 0.87868 29.1213C1.44129 29.6839 2.20435 30 3 30H24C24.7956 30 25.5587 29.6839 26.1213 29.1213C26.6839 28.5587 27 27.7956 27 27V6C27 5.20435 26.6839 4.44129 26.1213 3.87868C25.5587 3.31607 24.7956 3 24 3ZM24 27H3V12H24V27ZM3 9V6H24V9H3ZM7.845 23.115L9.435 24.705L13.095 21.045L16.755 24.705L18.345 23.115L14.685 19.455L18.345 15.795L16.755 14.205L13.095 17.865L9.435 14.205L7.845 15.795L11.505 19.455L7.845 23.115Z`,
                fill: theme.colorMain,
            }),
        );
    },
);
